"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateSchema = exports.getDateError = exports.optionalSchema = void 0;
const moment_1 = __importDefault(require("moment"));
const dateTime_1 = require("../../utils/dateTime");
const dateTimeFormat_1 = require("../../utils/dateTimeFormat");
const flatArray_1 = require("../../utils/flatArray");
const translation_1 = require("./translation");
const optionalSchema = (schema) => schema.optional();
exports.optionalSchema = optionalSchema;
const getDateError = (value, formatMessage, dateRestrictions = {}) => {
    var _a;
    const { disableFutureDays, disabledAfterDay, disablePastDays, disabledBeforeDay, notAllowedBeforeDate, notAllowedAfterDate, } = dateRestrictions;
    if (!value)
        return undefined;
    const date = (0, moment_1.default)(value, dateTimeFormat_1.DATE_OUTPUT_FORMAT);
    const today = (0, moment_1.default)().format(dateTimeFormat_1.DATE_OUTPUT_FORMAT);
    const tomorrow = (0, moment_1.default)().add(1, 'day').format(dateTimeFormat_1.DATE_OUTPUT_FORMAT);
    const allowedDays = (_a = (0, flatArray_1.flatArray)(dateRestrictions.allowedDays)) === null || _a === void 0 ? void 0 : _a.map(x => (0, moment_1.default)(x));
    if (allowedDays === null || allowedDays === void 0 ? void 0 : allowedDays.some(x => x.isSame(date, 'day')))
        return undefined;
    const getPastError = () => {
        if (date.year() < dateTime_1.defaultPastYear)
            return dateTime_1.defaultPastYear;
        const pastDates = [
            disablePastDays ? today : undefined,
            disabledBeforeDay,
            notAllowedBeforeDate,
        ];
        return pastDates.map(text => {
            if (!text)
                return undefined;
            const pastDate = (0, moment_1.default)(text, dateTimeFormat_1.DATE_OUTPUT_FORMAT);
            if (date.isSameOrAfter(pastDate, 'day'))
                return undefined;
            return pastDate.format(dateTimeFormat_1.DATE_FORMAT);
        }).find(x => x);
    };
    const pastError = getPastError();
    if (pastError) {
        return formatMessage(translation_1.validationMessages.dateTooPast, {
            date: pastError,
        });
    }
    const getFutureError = () => {
        const futureDates = [
            disableFutureDays ? tomorrow : undefined,
            disabledAfterDay,
            notAllowedAfterDate,
        ];
        return futureDates.map(text => {
            if (!text)
                return undefined;
            const futureDate = (0, moment_1.default)(text, dateTimeFormat_1.DATE_OUTPUT_FORMAT);
            if (date.isBefore(futureDate, 'day'))
                return undefined;
            return futureDate.format(dateTimeFormat_1.DATE_FORMAT);
        }).find(x => x);
    };
    const futureError = getFutureError();
    if (futureError) {
        return formatMessage(translation_1.validationMessages.dateTooFuture, {
            date: futureError,
        });
    }
    return undefined;
};
exports.getDateError = getDateError;
const dateSchema = (schema, formatMessage, dateRestrictions) => {
    const result = schema.superRefine((value, ctx) => {
        const error = (0, exports.getDateError)(value, formatMessage, dateRestrictions);
        if (!error)
            return;
        ctx.addIssue({
            code: 'custom',
            message: error,
        });
    });
    return result;
};
exports.dateSchema = dateSchema;
//# sourceMappingURL=schemaUtils.js.map